import {
  ESTADO_VERIFICACION_EFECTO,
  EstadoVerificacionEfectoType,
} from "api/Types/EstadoVerificacionEfecto"
import { formatNumber } from "common/utils/currency"
import { formatDate } from "common/utils/utils"
import { EstadosValidacionBodyTemplate } from "features/Validaciones/templates"
import { TFunction } from "i18next"

export interface RowDataValidaciones {
  id: string
  serie?: string
  cliente?: string
  razonSocial?: string
  fechaEmision?: string
  importe?: number
  cif?: string
  tipoDocumentoComercial?: number
  numFirmados?: number
  numFirmas?: number
  numero?: number
}

interface Factura {
  fechaEmision: string
  importe: number
  librador: {
    nif: string
    razonSocial: string
  }
  numero: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  tipo?: $TSMigrationFixMe
  divisa?: string
  id: string
  estado?: number
}

export const financiacionColumns = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  t: $TSMigrationFixMe,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onRenderCheckIcon: $TSMigrationFixMe,
  tab: string,
  isContactoPage?: boolean
) => {
  return [
    {
      key: "numEfecto",
      header: `${t("validaciones.financiable.table.numberEfectHeader")}`,
      sortable: false,
      filter: false,
      field: "numEfecto",
    },
    ...(isContactoPage
      ? []
      : [
          {
            key: "razonSocial",
            header: `${t("validaciones.financiable.table.nameCompanyHeader")}`,
            sortable: false,
            filter: false,
            field: "razonSocial",
          },
          {
            key: "nif",
            header: `${t("validaciones.financiable.table.nifHeader")}`,
            field: "nif",
            filter: false,
          },
        ]),
    {
      key: "fechaEmision",
      header: `${t("validaciones.financiable.table.dataEmisionHeader")}`,
      field: "fechaEmision",
      filter: false,
    },
    {
      key: "estado",
      header: `${t("validaciones.cesiones.table.columns.estado")}`,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      body: (rowData: $TSMigrationFixMe) =>
        EstadosValidacionBodyTemplate({ t, tab, ...rowData }),
      field: "estado",
      filter: false,
    },
    {
      key: "importe",
      header: `${t("validaciones.financiable.table.importHedaer")}`,
      field: "importe",
      filter: false,
    },
    {
      key: "botones",
      body: (props: RowDataValidaciones) => {
        if (onRenderCheckIcon) {
          return onRenderCheckIcon({ rowData: props })
        }
        return null
      },
      isFunctionComponent: true,
      headerStyle: {
        width: 80,
      },
      isInDetailView: false,
    },
  ]
}

export const FLOW_STATUS_AUTH_KEYS = ["aceptada", "rechazada"]

export const FLOW_STATUS_AUT_OPTIONS = (
  t: TFunction
): Array<{ label: string; value: EstadoVerificacionEfectoType }> => {
  return [
    {
      label: `${t("validaciones.financiable.idView.aceptLabel")}`,
      value: ESTADO_VERIFICACION_EFECTO.VERIFICADO,
    },
    {
      label: `${t("validaciones.financiable.idView.rejectLabel")}`,
      value: ESTADO_VERIFICACION_EFECTO.NO_VERIFICADO,
    },
  ]
}

export const mapResFin = (res: Factura[]) => {
  return res
    ?.map((factura: Factura) => ({
      fechaEmision: formatDate(factura.fechaEmision, "DD/MM/YYYY"),
      id: factura.id,
      nif: factura.librador.nif,
      razonSocial: factura.librador.razonSocial,
      numEfecto: factura.numero,
      tipo: `${factura.tipo ? factura.tipo : "Factura"}`,
      importe: `${formatNumber(factura.importe)} ${factura.divisa || "€"}`,
      estado: factura.estado,
    }))
    .sort((a, b) => (a.estado || 0) - (b.estado || 0))
}
